import React, { useState, useEffect } from "react";
import { FiUser } from "react-icons/fi";
import "../../styles/AboutSection.css";
import founderImg from '../../assets/founder.jpg';

export default function FounderSection() {
  const [founderData, setFounderData] = useState({
    name: "Dr Redouane EL MAJDOULI",
    role: "FONDATEUR IAMAR",
    subtitle: "Expert en Gouvernance Sécuritaire",
    quote: "Fort d'une expérience de plus de deux décennies au sein des institutions publiques, il développe une approche scientifique innovante articulant analyse stratégique, communication et technologies émergentes.",
    photoUrl: "",
    experienceTag: "20+ ANS D'EXPÉRIENCE",
    specialties: ["Analyse Stratégique", "Gouvernance", "Cyber-Sécurité"]
  });

  useEffect(() => {
    try {
      const saved = localStorage.getItem('iamar_institute_content');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (parsed.founder) {
          setFounderData(parsed.founder);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  const currentPhoto = founderData.photoUrl || founderImg;

  return (
    <section className="about-sub-section founder-section" id="fondateur">
      <div className="section-header-v2">
        <span className="accent-line"></span>
        <h2>LE FONDATEUR</h2>
      </div>

      <div className="founder-modern-layout">
        <div className="founder-visual-box">
          <div className="image-frame">
            <img src={currentPhoto} alt={founderData.name} className="founder-image-v3" />
            <div className="image-overlay">
              <FiUser className="overlay-icon" />
            </div>
            <div className="experience-tag">{founderData.experienceTag || "20+ ANS D'EXPÉRIENCE"}</div>
          </div>
        </div>

        <div className="founder-details-box">
          <div className="founder-header-v3">
            <span className="role-tag">{founderData.role}</span>
            <h3 style={{ margin: '6px 0', fontSize: '1.4rem', color: '#1b1e4f' }}>{founderData.name}</h3>
            <span className="founder-subtitle">{founderData.subtitle}</span>
          </div>
          
          <div className="founder-quote-v3">
            <p>"{founderData.quote}"</p>
          </div>

          <div className="founder-specialties-v3">
            {founderData.specialties && founderData.specialties.map((spec, i) => (
              <div key={i} className="spec-pill">{spec}</div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
